import React,{Component} from "react";
import {AppBackground, MediumFont, TextColor, ThinBorder} from '../../styles/BaseStyles';
import Grid from '@material-ui/core/Grid';
import PropTypes from 'prop-types';
import {withStyles} from '@material-ui/core/styles';
import MoneyCard from "./MoneyCard";
import TimeCard from "./TimeCard";
import Button from '@material-ui/core/Button';
import { shadows } from '@material-ui/system';
import { Link as RouterLink } from 'react-router-dom'
import Link from '@material-ui/core/Link';
import Typography from "@material-ui/core/Typography";
//Farshid
import Card from '@material-ui/core/Card';
import CardActions from '@material-ui/core/CardActions';
import CardContent from '@material-ui/core/CardContent';
//import Button from '@material-ui/core/Button';
import {bindActionCreators} from "redux";
import {loginAction, saveAComment, updateUserProfileAction} from "../../redux/modules/login";
import {connect} from "react-redux";
import Divider from "@material-ui/core/Divider";
import TextField from "@material-ui/core/TextField";
import {DEFAULT_VESPAAN_SERVER} from "../../utils/MainConstants";
import Image from 'material-ui-image'
import * as MainConstants from "../../utils/MainConstants";
import ReactPlayer from 'react-player';

import CreditCardForm from "./CreditCardForm.js";

//import {updateUserProfileAction, saveAComment} from "../../redux/modules/login";
//import {bindActionCreators} from "redux";
//import {connect} from "react-redux";
//import {DEFAULT_VESPAAN_SERVER} from "../../utils/MainConstants";
//End Farshid



const Styles = theme => ({
    root: Object.assign({}, AppBackground, MediumFont),
    gridPane: {width: '50%', display: 'inline-block'},
    paneTable: {width: '100%', height: '100%',  backgroundColor:'grey'},
    videoPane: {width: '50%', display: 'inline-block', verticalAlign: 'top'},
    penInfoPanel: {color: 'white', fontSize: 20},
    penInfoPanelSelected: Object.assign({color: 'white', fontSize: 20}, ThinBorder),
    videoPanel: {marginTop: 0},
    penName: {color: TextColor, fontSize: 20, marginLeft: 10, cursor: 'pointer', display: 'inline-block'},
    metricValue: {display: 'inline-block', width: 100, height: 100, cursor: 'pointer'},
    container: {
        display: 'grid',
        gridTemplateColumns: 'repeat(12, 1fr)',
        gridGap: `${theme.spacing.unit * 3}px`,
    },
    paper: {
        padding: theme.spacing.unit * 2,
        textAlign: 'center',
        color: theme.palette.text.secondary,
    },
    divider: {
        margin: `${theme.spacing.unit * 2}px 0`,
    },
    metricInfo: Object.assign({}, AppBackground, ThinBorder)

});

const styles = theme => ({
    container: {
        display: 'grid',
        gridTemplateColumns: 'repeat(12, 1fr)',
        gridGap: `${theme.spacing.unit * 3}px`,
    },
    paper: {
        padding: theme.spacing.unit,
        textAlign: 'center',
        color: theme.palette.text.secondary,
        whiteSpace: 'nowrap',
        marginBottom: theme.spacing.unit,
    },
    divider: {
        margin: `${theme.spacing.unit * 2}px 0`,
    },
    leftPane: {width: '25%', height: '100%', verticalAlign: 'top', backgroundColor:'red'},
    rightPane: {fontSize: 40, color: 'black', verticalAlign: 'top', backgroundcolor:'red'},
    formControl: {
        margin: theme.spacing.unit,
        minWidth: 120,
    },
    selectEmpty: {
        marginTop: theme.spacing.unit * 2,
    },
    button: {
        margin: theme.spacing.unit,
    },
    extendedIcon: {
        marginRight: theme.spacing.unit,
    },
    margin: {
        margin: theme.spacing.unit * 2,
    },
    dividerColorPurpole: {
        //marginTop: theme.spacing.unit * 3,
        height: '20px',
        color:"#ffffff",
        //backgroundColor:"#760eb3",
    },

    multilineColor:{
        color:'black',
        backgroundColor:'#f5f7e8'
    }
});


class OrchidProblems extends Component {

    state = {
        age: '',
        name: 'hai',
        firstname: '',
        lastname:'',
        email:'',
        comment:'',
        userComment:{},
        selectedUser:{},
        showOrderForm:false
    };

    constructor(props) {
        super(props);

        this.handleFirstNameChange = this.handleFirstNameChange.bind(this);
        this.handleLastNameChange = this.handleLastNameChange.bind(this);
        this.handleEmailChange= this.handleEmailChange.bind(this);
        this.handleCommentChange = this.handleCommentChange.bind(this);
        this.saveVisitorComment = this.saveVisitorComment.bind(this);

        this.handleAddress2Change = this.handleAddress2Change.bind(this);
        this.handleShowOrderFormChange = this.handleShowOrderFormChange.bind(this);



    }


    componentDidMount() {
        const { isAuthenticated ,updateUserProfileAction} = this.props;
        //isAuthenticated();
        //updateUserProfileAction(this.props.userProfile, this.props.loginData.accessToken);
        updateUserProfileAction(null, this.props.loginData.accessToken);
        //updateAuth();
        // console.log("Farshid the loginData " + this.props.loginData.accessToken)  ;

    }


    handleChange = event => {
        this.setState({ [event.target.name]: event.target.value });
    };

    handleShowOrderFormChange = event => {
        this.setState({ showOrderForm:!this.state.showOrderForm });
    };

    handleFirstNameChange(event) {
        //event.preventDefault();
        this.setState(Object.assign(this.state.userComment,{firstname:event.target.value}));

        //this.setState({userComment , {{firstname:event.target.value }});
        // this.setState(Object.assign(this.state.firstname, event.target.value));
    }

    handleLastNameChange(event) {
        //event.preventDefault();
        //this.setState(Object.assign(this.state.lastname, event.target.value));
        this.setState(Object.assign(this.state.userComment,{lastname:event.target.value}));

    }

    handleEmailChange(event) {
        //event.preventDefault();
        //this.setState(Object.assign(this.state.email,event.target.value));
        this.setState(Object.assign(this.state.userComment,{email:event.target.value}));

    }
    handleCommentChange(event) {
        //event.preventDefault();
        this.setState(Object.assign(this.state.userComment,{comment: event.target.value}));
    }


    saveVisitorComment(){
        const {saveAComment} = this.props;
        var  returnString="";
        var tempLastName =  this.state.userComment.lastname;
        var tempFirstName = this.state.userComment.firstname;
        var tempEmail = this.state.userComment.email;
        var tempComment = this.state.userComment.comment;


        if((tempFirstName == null) || (tempFirstName.length == 0)){
            alert("Please provide your first name!");
        }else {

            if ((tempLastName == null) || (tempLastName.length == 0)) {
                alert("Please provide your last name!");
            }else {

                if ((tempEmail == null) || (tempEmail.length == 0)) {
                    alert("Please provide your Email!");
                } else {

                    if ((tempEmail.indexOf("@") == -1)) {
                        alert("Please provide proper Email address!");
                    }else{
                        if ((tempComment == null) || (tempComment.length == 0)) {
                            alert("Please provide your comment!");
                        }else{
                            //Here send the data to the back end.
                            saveAComment(DEFAULT_VESPAAN_SERVER.url, this.state.userComment);

                        }
                    }
                }
            }
        }

        return returnString;
    }

//Background color was backgroundColor:'#f4f3ed',

    handleAddress2Change(event) {
        //event.preventDefault();
        this.setState(Object.assign(this.state.selectedUser,{address2:event.target.value}));
    }



    render() {
        let shorOrderFormButtonText="";
        const { classes } = this.props;
        const MyLink = props => <RouterLink to="#top2" {...props} />
        if( !this.state.showOrderForm){
            shorOrderFormButtonText = "Show Order Form";
        }else{
            shorOrderFormButtonText = "Hide Order Form";
        }
        return (

            <div id="top1"  style={{  }}>
                <Grid container spacing={24}>

                    <Grid   item xs={12} sm={12}  >


                        <div    style = { {  backgroundPosition:'center',  backgroundSize:'cover',  backgroundRepeat:'no-repeat'  }}>


                            {/*<Typography variant="h6" component="h2" style = { { textAlign: 'center', alignSelf: 'center'  , marginTop:10,  color:'#BF360C', fontSize:30}}>
                About {MainConstants.APPLICATION_NAME}&trade;
              </Typography>*/}

                            <h6 style = { {textAlign: 'center', alignSelf: 'center', color:'Red', fontSize:20}} ></h6>

                            <div style = { {textAlign: 'center', alignSelf: 'center', paddingBottom:'200', marginBottom:'100', width:'300'}}>

                            </div>


                            <h6 style = { {textAlign: 'center', alignSelf: 'center', color:'Red', fontSize:20}} ></h6>


                            <a href="/Home"   rel="noreferrer">
                                <Typography component="h1" variant="h6" style = { { color:'blue', marginLeft:20}} >
                                    Back to Orchima Home
                                </Typography>
                            </a>

                            <Typography variant="h6" component="h2" style = { { textAlign: 'center', alignSelf: 'center'  , color:'#BF360C', fontSize:30}}>
                                Orchid’s challenges
                            </Typography>

                            <h6 style = { {textAlign: 'center', alignSelf: 'center', color:'Red', fontSize:20}} ></h6>

                            <div style = { {textAlign: 'center', alignSelf: 'center', paddingBottom:'200', marginBottom:'100', width:'300'}}>
                                <Grid container spacing={24}>
                                    <Grid   item xs={1} sm={1}  >
                                    </Grid>
                                    <Grid   item xs={10} sm={10}  >
                                        <Typography variant="h6" component="h6" style = { {textAlign: 'left', alignSelf: 'center', paddingBottom:'200', marginBottom:'100', width:'300'}}>
                                            Growing orchids at home can be rewarding, but many people struggle because orchids are not like typical houseplants.
                                            Here are the most common problems people face:
                                        </Typography>

                                        <br/>

                                        <Typography variant="h6" component="h6" style = { {textAlign: 'left', alignSelf: 'center', paddingBottom:'200', marginBottom:'100', topPadding:'100', width:'300'}}>

                                        </Typography>

                                        <ul>
                                            <li style = { { textAlign: 'left', alignSelf: 'left' , fontSize:20, color:'#e2580d', }}><span style = { { textAlign: 'left', alignSelf: 'left' , fontSize:20, color:'#e2580d', paddingTop:'50'}} > Overwatering / Root Rot - </span>
                                                <Grid container spacing={24}  >
                                                    <Grid   item xs={12} sm={12}  md={8} lg={8}   xl={8} >
                                                        <div  style={{ marginRight:40 }}>
                                                            <span style = { { textAlign: 'left', alignSelf: 'left' , fontSize:20, color:'black'  }}> Most beginners water orchids too often or use non-draining pots, which leads to root rot. Orchids need air around their roots — not constantly wet soil.</span>
                                                        </div>
                                                    </Grid>
                                                    <Grid   item xs={12} sm={12}  md={4} lg={4}   xl={4}  >
                                                        <div  style={{ marginRight:70, marginLeft:10, marginTop:0,  marginBotton:10}}>
                                                            <Image
                                                                //src="/static/images/IMG_3615.JPG"
                                                                src="/static/images/orchid-roots-original-pot-720x960.jpg"
                                                                aspectRatio='(6/6)'
                                                            />
                                                        </div>
                                                    </Grid>

                                                </Grid>
                                            </li>
                                            <br/>
                                            <li style = { { textAlign: 'left', alignSelf: 'left' , fontSize:20, color:'#e2580d', paddingTop:10}}><span style = { { textAlign: 'left', alignSelf: 'left' , fontSize:20, color:'#e2580d'}} > Lack of Air Circulation - </span>
                                                <Grid container spacing={24}  >
                                                    <Grid   item xs={12} sm={12}  md={8} lg={8}   xl={8} >
                                                        <div  style={{ marginRight:40 }}>
                                                      <span style = { { textAlign: 'left', alignSelf: 'left' , fontSize:20, color:'black'}}>Orchids naturally grow on trees in breezy environments.
                                                        In still, stuffy rooms, their roots suffocate or develop fungus. </span>
                                                        </div>
                                                    </Grid>
                                                    <Grid   item xs={12} sm={12}  md={4} lg={4}   xl={4}  >
                                                        <div  style={{ marginRight:60, marginLeft:10, marginTop:0,  marginBotton:10}}>
                                                            <Image
                                                                //src="/static/images/IMG_3615.JPG"
                                                                src="/static/images/Orchidfungus.png"
                                                                aspectRatio='(4/4)'
                                                            />
                                                        </div>
                                                    </Grid>

                                                </Grid></li>
                                            <br/>
                                            <li style = { { textAlign: 'left', alignSelf: 'left' , fontSize:20, color:'#e2580d', paddingTop:10}}><span style = { { textAlign: 'left', alignSelf: 'left' , fontSize:20, color:'#e2580d'}} > Incorrect Temperature or Light - </span>
                                                <Grid container spacing={24}  >
                                                    <Grid   item xs={12} sm={12}  md={8} lg={8}   xl={8} >
                                                        <div  style={{ marginRight:40 }}>
                                                    <span style = { { textAlign: 'left', alignSelf: 'left' , fontSize:20, color:'black'}}>Orchids prefer bright, indirect light — too much sun scorches them, too little prevents blooming.
                                                    They also need a 10–15°F drop at night to trigger blooming, which many homes don’t naturally provide. </span>
                                                        </div>
                                                    </Grid>
                                                    <Grid   item xs={12} sm={12}  md={4} lg={4}   xl={4}  >
                                                        <div  style={{ marginRight:60, marginLeft:10, marginTop:0,  marginBotton:10}}>
                                                            <Image
                                                                //src="/static/images/IMG_3615.JPG"
                                                                src="/static/images/Sunburn-Spot-on-Orchid-Foliage.jpg"
                                                                aspectRatio='(6/6)'
                                                            />
                                                        </div>
                                                    </Grid>

                                                </Grid>
                                            </li>
                                            <br/>
                                            <li style = { { textAlign: 'left', alignSelf: 'left' , fontSize:20, color:'#e2580d' , paddingTop:10}}><span style = { { textAlign: 'left', alignSelf: 'left' , fontSize:20, color:'#e2580d'}} > Low Humidity- </span>

                                                <Grid container spacing={24}  >
                                                    <Grid   item xs={12} sm={12}  md={8} lg={8}   xl={8} >
                                                        <div  style={{ marginRight:40 }}>
                                                      <span style = { { textAlign: 'left', alignSelf: 'left' , fontSize:20, color:'black'}}>Homes often have dry air, especially with central heating or AC. Orchids thrive at 50–70% humidity, so low levels dry out buds and leaf tips.
                                                        </span>
                                                        </div>
                                                    </Grid>
                                                    <Grid   item xs={12} sm={12}  md={4} lg={4}   xl={4}  >
                                                        <div  style={{ marginRight:70, marginLeft:10, marginTop:0,  marginBotton:10}}>
                                                            <Image
                                                                //src="/static/images/IMG_3615.JPG"
                                                                src="/static/images/OrchidWrinkled.jpg"
                                                                aspectRatio='(6/6)'
                                                            />
                                                        </div>
                                                    </Grid>

                                                </Grid></li>
                                            <br/>
                                            <li style = { { textAlign: 'left', alignSelf: 'left' , fontSize:20, color:'#e2580d', paddingTop:10}}><span style = { { textAlign: 'left', alignSelf: 'left' , fontSize:20, color:'#e2580d'}} > Poor Potting Medium - </span>
                                                <Grid container spacing={24}  >
                                                    <Grid   item xs={12} sm={12}  md={8} lg={8}   xl={8} >
                                                        <div  style={{ marginRight:40 ,}}>
                                                    <span style = { {  fontSize:20, color:'black'}}>People often use regular potting soil, which retains too much water. Orchids need a loose, fast-draining mix like bark, sphagnum moss, or perlite.
                                                      Excess moisture retention, moss holds an exceptionally high amount of water, potentially leading to root suffocation and rot.
                                                   <br/> <br/>Risk of compaction, If moss becomes too dense, it significantly reduces air circulation to the roots, impairing their health.
                                                       <br/> <br/>Not ideal for long-term growth, Sphagnum moss, while useful for shipping young orchids, degrades and turns acidic over time—requiring repotting and change to more breathable media.
                                                    </span>
                                                        </div>
                                                    </Grid>
                                                    <Grid   item xs={12} sm={12}  md={4} lg={4}   xl={4}  >
                                                        <div  style={{ marginRight:70, marginLeft:10, marginTop:10,  marginBotton:10}}>
                                                            <Image
                                                                //src="/static/images/IMG_3615.JPG"
                                                                src="/static/images/OrchidWithMoss.jpeg"
                                                                aspectRatio='(6/6)'
                                                            />
                                                        </div>
                                                    </Grid>

                                                </Grid>
                                            </li>
                                            <br/>
                                            <li style = { { textAlign: 'left', alignSelf: 'left' , fontSize:20, color:'#e2580d', paddingTop:10}}><span style = { { textAlign: 'left', alignSelf: 'left' , fontSize:20, color:'#e2580d'}} > Failure to Rebloom - </span>
                                                <Grid container spacing={24}  >
                                                    <Grid   item xs={12} sm={12}  md={8} lg={8}   xl={8} >
                                                        <div  style={{ marginRight:40 }}>
                                                    <span style = { { textAlign: 'left', alignSelf: 'left' , fontSize:20, color:'black'}}>Many orchid owners keep the plant alive but can’t get it to bloom again.
                                                    Common causes, not enough light, no temperature drop at night, or insufficient feeding.
                                                    </span>
                                                        </div>
                                                    </Grid>
                                                    <Grid   item xs={12} sm={12}  md={4} lg={4}   xl={4}  >
                                                        <div  style={{ marginRight:70, marginLeft:10, marginTop:0,  marginBotton:10}}>
                                                            <Image
                                                                //src="/static/images/IMG_3615.JPG"
                                                                src="/static/images/OrchidNoBloom.png"
                                                                aspectRatio='(9/6)'
                                                            />
                                                        </div>
                                                    </Grid>

                                                </Grid>

                                            </li>
                                            <br/>
                                            <li style = { { textAlign: 'left', alignSelf: 'left' , fontSize:20, color:'#e2580d', paddingTop:10}}><span style = { { textAlign: 'left', alignSelf: 'left' , fontSize:20, color:'#e2580d'}} > Wrong Pot Choice - </span>
                                                <Grid container spacing={24}  >
                                                    <Grid   item xs={12} sm={12}  md={8} lg={8}   xl={8} >
                                                        <div  style={{ marginRight:40 }}>
                                                    <span style = { { textAlign: 'left', alignSelf: 'left' , fontSize:20, color:'black'}}>Decorative ceramic pots with no drainage holes are popular — but deadly for orchids.
                                                        Orchids need pots that allow air flow and let excess water escape.
                                                    </span>
                                                        </div>
                                                    </Grid>
                                                    <Grid   item xs={12} sm={12}  md={4} lg={4}   xl={4}  >
                                                        <div  style={{ marginRight:70, marginLeft:10, marginTop:0,  marginBotton:10}}>
                                                            <Image
                                                                //src="/static/images/IMG_3615.JPG"
                                                                src="/static/images/orchidceramicpot.jpg"
                                                                aspectRatio='(9/6)'
                                                            />
                                                        </div>
                                                    </Grid>

                                                </Grid>

                                            </li>
                                        </ul>
                                    </Grid>
                                    <Grid   item xs={1} sm={1}  >
                                    </Grid>
                                </Grid>
                            </div>

                            <br/>
                            <br/>

                            <br/>

                            <a href="/privacy"   rel="noreferrer" style={{paddingLeft:10, paddingBottom:20, display: 'flex', flexDirection: 'row', justifyContent: 'center' }}>
                                <Typography component="h2" variant="body1" style = { { color:'blue'}} >
                                    Privacy Policy
                                </Typography>
                            </a>

                            <a href="/Home"   rel="noreferrer" style={{paddingLeft:10, paddingBottom:20, display: 'flex', flexDirection: 'row', justifyContent: 'center' }}>
                                <a href="/Home"   rel="noreferrer">
                                    <Typography component="h1" variant="h6" style = { { color:'blue', marginLeft:20}} >
                                        Back to Orchima Home
                                    </Typography>
                                </a>
                            </a>

                        </div>
                    </Grid>
                </Grid>
            </div>



        );
    }
}

OrchidProblems.propTypes = {
    classes: PropTypes.object.isRequired,
};

const mapStateToProps = (state) => {
    return {
        isAuthenticatedBool: state.login.isAuthenticatedBool,
        userProfile: state.login.userProfile,
        loginData:state.login.loginData,


    };
};

const mapDispatchToProps = (dispatch) => {
    return bindActionCreators({
        //login:login,
        //handleAuthentication:handleAuthentication,
        //isAuthenticated:isAuthenticated,
        updateUserProfileAction:updateUserProfileAction,
        saveAComment:saveAComment,
        //updateAuth:updateAuth,

    }, dispatch);
};

//export default BiomassView;
//export default withStyles(styles)(AboutPlateWiz);




//export default withStyles(styles)(AppView);
export default connect(mapStateToProps, mapDispatchToProps)(withStyles(styles)(OrchidProblems));
